import { render, staticRenderFns } from "./QuizModal.vue?vue&type=template&id=9b5ba34a&"
import script from "./QuizModal.vue?vue&type=script&lang=js&"
export * from "./QuizModal.vue?vue&type=script&lang=js&"
import style0 from "./QuizModal.vue?vue&type=style&index=0&id=9b5ba34a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports